import React from "react";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import InsightsIcon from "@mui/icons-material/Insights";

const FeedbackPopup = ({ isOpen, onClose, feedbackItems, percentage }) => {
  if (!feedbackItems) return null;

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="feedback-modal-title"
      className="common-popup-overlay feedback-popup-overlay"
    >
      <div className="feedback-popup-container">
        <div className="feedback-popup-header">
          <div className="feedback-popup-title-box">
            <div className="feedback-popup-title" id="feedback-modal-title">
              Performance Analysis
            </div>
            <div className="feedback-popup-subtitle">
              Student scored {percentage}% in this assessment.
            </div>
          </div>
          <IconButton
            onClick={onClose}
            className="feedback-popup-close-btn"
            size="small"
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.04)",
              borderRadius: "50%",
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>

        <div className="feedback-popup-content custom-scrollbar">
          {feedbackItems.length > 0 ? (
            feedbackItems.map((fb, index) => {
              const scoreColor =
                percentage < 50
                  ? "var(--feedback-needs-improvement, #ef4444)"
                  : percentage <= 75
                    ? "var(--feedback-good, #f59e0b)"
                    : "var(--feedback-excellent, #10b981)";
              const scoreBg =
                percentage < 50
                  ? "var(--feedback-needs-improvement-bg, #ffe4e9)"
                  : percentage <= 75
                    ? "var(--feedback-good-bg, #fff8e1)"
                    : "var(--feedback-excellent-bg, #e9f9ef)";

              return (
                <div
                  key={index}
                  className="feedback-popup-item-section custom-scrollbar"
                  style={{ marginBottom: "16px" }}
                >
                  <div className="feedback-popup-item-header" style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "10px 18px",
                    background: "linear-gradient(to right, rgba(248, 250, 252, 0.8), rgba(255, 255, 255, 0))"
                  }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      <InsightsIcon
                        className="feedback-popup-section-icon"
                        style={{ color: scoreColor, fontSize: "1.4rem" }}
                      />
                      <div
                        className="feedback-popup-section-title"
                        style={{ color: scoreColor, fontWeight: 800, fontSize: "1.1rem" }}
                      >
                        {fb.title || "Subject Feedback"}
                      </div>
                    </div>
                    <div
                      className="feedback-popup-section-badge"
                      style={{
                        backgroundColor: scoreColor,
                        marginLeft: "auto",
                        padding: "4px 12px",
                        color: "white",
                        borderRadius: "8px",
                        fontSize: "0.75rem",
                        fontWeight: 800,
                        textTransform: "uppercase"
                      }}
                    >
                      {fb.performance_level}
                    </div>
                  </div>

                  <div className="feedback-card-body" style={{ padding: "20px", display: "flex", flexDirection: "column", gap: "20px" }}>
                    {fb.weak_topics && fb.weak_topics.length > 0 && (
                      <div className="feedback-section-item">
                        <div className="section-label" style={{ fontWeight: 700, textTransform: "uppercase", fontSize: "0.75rem", color: "#6b7280", marginBottom: "8px" }}>
                          Areas to Focus On:
                        </div>
                        <div className="topics-grid" style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                          {fb.weak_topics.map((topic, topicIndex) => (
                            <span key={topicIndex} className="topic-tag" style={{
                              backgroundColor: "#f3f4f6",
                              color: "#374151",
                              padding: "6px 14px",
                              borderRadius: "99px",
                              fontSize: "0.85rem",
                              fontWeight: 600,
                              border: "1px solid #e5e7eb"
                            }}>
                              {topic}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}

                    {fb.improvement_advice && (
                      <div className="feedback-section-item">
                        <div className="section-label" style={{ fontWeight: 700, textTransform: "uppercase", fontSize: "0.75rem", color: "#6b7280", marginBottom: "8px" }}>
                          Recommendations:
                        </div>
                        <div
                          className="advice-text"
                          style={{
                            borderLeft: `4px solid ${scoreColor}`,
                            backgroundColor: scoreBg,
                            color: scoreColor,
                            padding: "12px",
                            borderRadius: "8px",
                            fontWeight: 500,
                            lineHeight: 1.6,
                            fontSize: "0.95rem"
                          }}
                        >
                          {fb.improvement_advice}
                        </div>
                      </div>
                    )}

                    {fb.content && (
                      <div className="feedback-section-item">
                        <div className="content-text" style={{ color: "#4b5563", lineHeight: 1.6, fontSize: "0.9rem", fontStyle: "italic" }}>
                          {fb.content}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <div className="empty-feedback" style={{ textAlign: "center", padding: "40px 20px", color: "#9ca3af" }}>
              <div>No detailed feedback currently available.</div>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default FeedbackPopup;
